import React, { useContext, useEffect, useState } from "react";
import backIcon from "../../../assets/Review/back-icon.svg";
import image1 from "../../../assets/Review/image1.svg";
import DebounceInput from "../../../common/DebounceInput";
import SearchIcon from "../../../assets/CreateCategory/SeachIcon.svg";
import successIcon from "../../../assets/Review/success.svg";
import "./style.scss";
import { useNavigate, useParams } from "react-router-dom";
import {
  useAcceptSkuOnReview,
  useGetAllSkusForReview,
} from "../../../hooks/useReview";
import { Empty, message, Modal, Tooltip } from "antd";
import ViewFileDetails from "../ViewFileDetails";
import pendingIcon from "../../../assets/Review/pendingIcon.svg";
import rejectedIcon from "../../../assets/Review/rejected.svg";
import { BatchMarketPlaceContext } from "../../../context/batchProvider";

const ReviewSkuList = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [activeMarketPlaceTab, setActiveMarketPlaceTab] = useState("All");
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const [skuLists, setSKuLists] = useState([]);
  const [reviewStatus, setReviewStatus] = useState("");
  const [batchList, setBatchList] = useState({});
  const [search, setSearch] = useState("");

  const { review_acceptedSkus, review_setAcceptedSkus } = useContext(
    BatchMarketPlaceContext
  );
  const statusDetails = {
    600: { src: pendingIcon, alt: "pending", title: "Pending" },
    700: { src: pendingIcon, alt: "pending", title: "Pending" },
    606: { src: successIcon, alt: "success", title: "Accepted" },
    706: { src: successIcon, alt: "success", title: "Accepted" },
    608: { src: rejectedIcon, alt: "reject", title: "Rejected" },
    708: { src: rejectedIcon, alt: "reject", title: "Rejected" },
  };
  const tabsData = [
    {
      id: 1,
      title: "All",
      isGlobalTab: true,
      status: "",
    },
    {
      id: 2,
      title: "Pending",
      isGlobalTab: true,
      status: "pending",
    },
    {
      id: 3,
      title: "Accepted",
      isGlobalTab: true,
      status: "approved",
    },
    {
      id: 4,
      title: "Rejected",
      isGlobalTab: true,
      status: "rejected",
    },
    // {
    //   id: 5,
    //   title: "Rework",
    //   isGlobalTab: true,
    //   status:''
    // },
  ];

  const handleSearch = (e) => {
    setSearch(e?.target?.value);
  };

  const handleTabActive = (id) => {
    setActiveTab(id);
  };

  const handleMarketPlaceTab = (id) => {
    setActiveMarketPlaceTab(id);
  };
  const onSuccessGetAllBatchesForReview = (res) => {
    if (res.status === 200) {
      setSKuLists(res.data.data?.skus);
      setBatchList(res?.data?.data?.batch);
    }
  };

  const onErrorGetAllBatchesForReview = (err) => {
    console.log(err);
  };

  const { data, refetch: getAllBatchesForSkus } = useGetAllSkusForReview(
    "getBatchForReview",
    params?.batchId,
    reviewStatus,
    onSuccessGetAllBatchesForReview,
    onErrorGetAllBatchesForReview
  );

  const onSuccessAcceptSkuOnReview = (res) => {
    if (res.status === 200) {
      message.success("Sku Accepted Successfully");
      getAllBatchesForSkus();
    }
  };

  const onErrorAcceptSkuOnReview = (err) => {
    console.log(err);
  };

  const { mutate: acceptSkuOnReview } = useAcceptSkuOnReview(
    onSuccessAcceptSkuOnReview,
    onErrorAcceptSkuOnReview
  );

  const handleAccept = (id) => {
    acceptSkuOnReview(id);
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date?.getDate()).padStart(2, "0");
    const month = String(date?.getMonth() + 1).padStart(2, "0");
    const year = date?.getFullYear();
    const hours = String(date?.getHours()).padStart(2, "0");
    const minutes = String(date?.getMinutes()).padStart(2, "0");
    const seconds = String(date?.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  const getTitle = () => {
    return (
      <div className="title">
        <img src={backIcon} alt="" />
        File Details
      </div>
    );
  };

  const getFileDetails = () => {
    return (
      <Modal
        title={getTitle()}
        centered
        open={open}
        footer={null}
        width="80%"
        height="auto"
        className="create_file_details"
        onCancel={() => setOpen(false)}
      >
        <ViewFileDetails />
      </Modal>
    );
  };

  const getReviewHeader = () => {
    return (
      <div className="review_header">
        <div className="left_header">
          <div className="back_action">
            <img
              src={backIcon}
              alt=""
              onClick={() => navigate("/review-batch-list")}
            />
          </div>
          <div className="batch_name">
            <h2>{batchList?.name} </h2>
            <div className="batch_details">
              <span>{skuLists?.length} SKU's</span>
              <div className="date_time">
                <h3>
                  {batchList?.updatedAt
                    ? formatTimestamp(batchList.updatedAt)
                    : ""}
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div className="right_search">
          <div className="search_wrapper">
            <input
              type="text"
              placeholder="Search"
              value={search}
              className="search_text"
              onChange={handleSearch}
            />
            <div className="searchIcon_wrapper">
              <img src={SearchIcon} alt="searchIcon" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getReviewTabs = () => {
    return (
      <div className="review_tabs">
        <div className="tabs_list">
          {tabsData.map((tab) => {
            return (
              <button
                className={`tab ${activeTab === tab?.id ? "active" : ""}`}
                onClick={() => {
                  handleTabActive(tab?.id);
                  setReviewStatus(tab?.status);
                }}
              >
                {tab?.title}
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  const getReviewContent = (sku) => {
    let imageCount = sku?.processFiles?.map(
      (process) => process?.files?.length
    );
    return (
      <div className="review_content">
        <div className="content_header">
          <div className="content_left">
            <div className="sku_details">
              <h2>{sku?.skuName}</h2>
              <span>
                {imageCount} {`${imageCount === 1 ? "Image" : "Images"}`}
              </span>
            </div>
          </div>
          <div className="content_right">
            <div className="action_buttons">
              {/* <button onClick={() => setOpen(true)}>View</button> */}
              {(activeMarketPlaceTab === "All"
                ? sku?.processFiles?.some((obj) =>
                    obj.files?.some(
                      (file) => file.status === 600 || file.status === 700
                    )
                  )
                : sku?.processFiles
                    .find((obj) => obj.marketplaceId === activeMarketPlaceTab)
                    ?.files?.some(
                      (file) => file.status === 600 || file.status === 700
                    )) && (
                <button
                  onClick={() => {
                    handleAccept(sku?._id);
                  }}
                  className={`${sku?.isWebhookCalled && "disabledBtn"}`}
                  disabled={sku?.isWebhookCalled}
                >
                  Accept All
                </button>
              )}
            </div>
          </div>
        </div>
        {open && getFileDetails()}
      </div>
    );
  };

  const getMarketPlaceImages = (skuId, processFiles) => {
    const displayedFiles =
      activeMarketPlaceTab === "All"
        ? processFiles.flatMap((obj) => obj.files)
        : processFiles.find((obj) => obj.marketplaceId === activeMarketPlaceTab)
            ?.files || [];

    return (
      <>
        <div className="marketplace_images">
          <div className="marketplace_tabs">
            <div
              className={`tab ${
                activeMarketPlaceTab === "All" ? "active" : ""
              }`}
              onClick={() => handleMarketPlaceTab("All")}
            >
              All
            </div>
            {processFiles.map((tab) => {
              return (
                <button
                  className={`tab ${
                    activeMarketPlaceTab === tab?.marketplaceId ? "active" : ""
                  }`}
                  onClick={() => handleMarketPlaceTab(tab?.marketplaceId)}
                >
                  {tab?.marketplaceName}
                </button>
              );
            })}
          </div>
        </div>

        <div className="sku_listing_section">
          <div className="skus_wrapper">
            {displayedFiles?.map((file) => {
              return (
                <div className="image_wrapper">
                  <div className="image">
                    {statusDetails[file?.status] ? (
                      <Tooltip
                        title={statusDetails[file.status].title}
                        placement="rightTop"
                      >
                        <img
                          src={statusDetails[file.status].src}
                          alt={statusDetails[file.status].alt}
                          className="success_icon"
                        />
                      </Tooltip>
                    ) : (
                      ""
                    )}

                    <img
                      src={file?.deliverable.displayFile?.thumbPath?.url}
                      alt=""
                      onClick={() =>
                        navigate(
                          `/review-detail/${params?.batchId}/${skuId}/${file?._id}`
                        )
                      }
                    />
                  </div>
                  {file?.mainFile?.image?.name?.length > 15 ? (
                    <Tooltip
                      title={file?.mainFile?.image?.name}
                      placement="rightTop"
                    >
                      <span>
                        {`${file?.mainFile?.image?.name.slice(0, 15)}...`}
                      </span>
                    </Tooltip>
                  ) : (
                    file?.mainFile?.image?.name
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  };

  const getSkus = () => {
    return (
      <div className="sku_list_content">
        {skuLists?.length > 0 ? (
          skuLists.filter((sku) => {
            if (!search?.trim()) {
              return true;
            }
            const regex = new RegExp(`\\b${search.toLowerCase()}\\b`, "i");
            return (
              sku?.skuName?.toLowerCase().includes(search.toLowerCase()) ||
              regex.test(sku?.skuName?.toLowerCase())
            );
          }).length > 0 ? (
            skuLists
              .filter((sku) => {
                if (!search?.trim()) {
                  return true;
                }
                const regex = new RegExp(`\\b${search.toLowerCase()}\\b`, "i");
                return (
                  sku?.skuName?.toLowerCase().includes(search.toLowerCase()) ||
                  regex.test(sku?.skuName?.toLowerCase())
                );
              })
              .map((sku, index) => (
                <div className="sku_innerListing" key={index}>
                  {getReviewContent(sku)}
                  {sku?.processFiles.length === 0 ? (
                    <div className="empty_container">
                      <Empty description={"No Data Found"} />
                    </div>
                  ) : (
                    getMarketPlaceImages(sku?._id, sku?.processFiles)
                  )}
                </div>
              ))
          ) : (
            <div className="empty_container">
              <Empty description={"No Data Found"} />
            </div>
          )
        ) : (
          <div className="empty_container">
            <Empty description={"No Data Found"} />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="review_section_container">
      <div className="review_content_wrapper">
        {getReviewHeader()}
        {getReviewTabs()}
        <div className="sku_list_container">{getSkus()}</div>
      </div>
    </div>
  );
};

export default ReviewSkuList;
